export const renderAges = (principalAge: number, spouseAge: number) => {
  if (!principalAge) {
    return '-';
  }

  return `${principalAge}${spouseAge ? ` / ${spouseAge}` : ''}`;
};
